"use client";

import AddIcon from "@/components/atoms/svg/icons/AddIcon";
import AgentList from "@/components/organisms/AgentList";
import { Button } from "@/components/ui/button";
import { useAgentProvider } from "@/features/home/contexts/AgentProvider";
import { IAgentData } from "@/interfaces/IAgentData";
import Link from "next/link";
import { Fragment } from "react";
import Paginate from "@/components/atoms/paginate/Paginate";
import { SORT_BY_MENU } from "@/constants/menu";

interface IHomeAgentsProps {
  initialLatestAgents: IAgentData[];
  initialPopularAgents: IAgentData[];
}

export default function HomeAgents({
  initialLatestAgents: latestAgents,
  initialPopularAgents: popularAgents,
}: IHomeAgentsProps) {
  const {
    isDataAgentsLoading,
    isFiltering,
    agentsFiltered,
    pageInfo,
    setPage,
    setIsFiltering,
  } = useAgentProvider();

  return (
    <div className="flex flex-col gap-12">
      {/* If not filter or search then, show default data that get from server  */}
      {!isFiltering && (
        <Fragment>
          <section>
            {/* Trending */}
            <div className="flex justify-between items-center mb-8">
              <p className="text-primary font-medium text-2xl">Trending</p>
              <Link href={`/explore?sort=${SORT_BY_MENU[1].id}`}>
                <Button className="flex justify-center items-center btn-default h-10">
                  <AddIcon />
                  <span>View More</span>
                </Button>
              </Link>
            </div>
            <AgentList
              className="sm:grid-cols-2 md:grid-cols-4"
              dataAgents={latestAgents || []}
              isDataAgentsLoading={false}
            />
          </section>
          <section>
            {/* Latest */}
            <div className="flex justify-between items-center mb-8">
              <p className="text-primary font-medium text-2xl">Latest</p>
              <Link href={`/explore?sort=${SORT_BY_MENU[0].id}`}>
                <Button className="flex justify-center items-center btn-default h-10">
                  <AddIcon />
                  <span>View More</span>
                </Button>
              </Link>
            </div>
            <AgentList
              className="sm:grid-cols-2 md:grid-cols-4"
              dataAgents={popularAgents || []}
              isDataAgentsLoading={false}
            />
          </section>
        </Fragment>
      )}

      {/* If Filtering */}
      {isFiltering && (
        <section>
          <AgentList
            className="sm:grid-cols-2 md:grid-cols-4"
            dataAgents={agentsFiltered || []}
            isDataAgentsLoading={isDataAgentsLoading || false}
          />
          <Paginate
            className="mt-[74] mb-[99px]"
            pageSelected={pageInfo?.pages || 1}
            pageCount={pageInfo?.totalPages || 1}
            handlePageClick={(event) => {
              setPage?.(event.selected + 1);
              setIsFiltering?.(true);
            }}
          />
        </section>
      )}
    </div>
  );
}
